<template>
  <div class="search-page">
    <div class="tabs-content">
      <van-sticky :offset-top="0">
        <van-search ref="searchRef" class="search-content" :autofocus="true" v-model="searchVal" shape="round" background="#fff" :placeholder="$t('form.namePostCodeAddressCity')" @input="(val) => handleSearch(val, 'search')" @clear="(val) => handleSearch(val, 'clear')">
          <van-icon slot="left" class="search-left-icon" name="arrow-left" size="23" @click="goBack" />
        </van-search>
        <FilterCustom :ref="`filterCustom`" :pageType="pageType" :deptOption="deptOption" @changeFilter="confirmFilter" />
      </van-sticky>
      <van-pull-refresh v-model="isLoading" @refresh="pullDownRefreshFn">
        <van-list v-model="loading" :finished="finished" :finished-text="finishedText" offset="60" :immediate-check="false" @load="pullUpLoadMoreFn">
          <Store ref="storeRef" :arr="storeList" :currentProject="filterData" @getCurrentLoc="getCurrentLoc" />
        </van-list>
      </van-pull-refresh>
    </div>
    <XuStoreSelect v-model="showStorePicker" @confirm="onConfirmStore" pageType="incentive" />
    <div v-if="storeList.length === 0 && searchVal" class="no-invite-store">
      <!-- 无符合条件的门店 -->
      <!-- <van-empty description="No Stores Match the Criteria" /> -->
      <!-- 邀约门店参与 -->
      <div class="invite-btn" @click="handleOper">{{ $t('button.inviteStoresToParticipate') }}</div>
    </div>
  </div>
</template>

<script>
import {
  arsCustomerAppListPageApi,
  deptTreeDeptApi
} from '@/api/home'
import { Toast } from 'vant'
import Store from '../Incentive/components/store'
import FilterCustom from '@/components/FilterCustom'
import { mapState } from 'vuex'
export default {
  name: 'Saerch',
  components: {
    Store,
    FilterCustom: FilterCustom,
    XuStoreSelect: () => import('@/components/XuStoreSelect')
  },
  data () {
    return {
      isLoading: false, // 下拉的加载状态
      loading: false, // 上拉每一页的加载状态
      finished: false, // 上拉是否全部加载完毕
      storeList: [], // 文字列表
      paginationList: {
        page: 1,
        limit: 10,
        total: 0
      },
      geocoder: null,
      pageType: 'incentive',
      deptOption: [],
      filterData: {
        sortVal: '',
        sortLabel: '',
        customerTag: '',
        shelfOperate: '',
        shelfProductIdList: [],
        deptIdList: [],
        userIdList: [],
        personVal: [],
        isPopUpEvent: ''
      },
      searchVal: '',
      finishedText: this.$t('tips.nothingMore'),
      showStorePicker: false
    }
  },
  computed: {
    ...mapState({
      userInfo: 'myUserInfo'
    })
  },
  watch: {
    $route (newVal) {
      this.$nextTick(() => {
        if (this.$route.meta.scrollY) {
          window.scrollTo(0, this.$route.meta.scrollY)
        }
      })
    }
  },
  beforeRouteLeave (to, from, next) {
    // 可以访问组件实例 `this`
    // 把滚动的高度 保存到 路由对象的meta字段中的scrollY上
    // if (to.path === '/storeExpansion/storeMappin') {
    //   from.meta.scrollY = window.scrollY
    // } else
    if (to.path === '/incentive/incentiveSearch') {
      from.meta.scrollY = 0
      this.$destroy()
    }
    next()
  },
  created () {
    this.finished = true
  },
  mounted () {
    // this.finished = true
    this.finishedText = this.$t('tips.messageThirtyFive')
    this.$nextTick(() => {
      // this.$refs.searchRef.focus()
      this.$el.querySelector('.van-field__control').focus()
      // this.$refs.searchRef.querySelector('input').focus()
    })
  },
  methods: {
    handleOper () {
      this.showStorePicker = true
    },
    goBack () {
      this.$destroy()
      this.$router.go(-1)
    },
    getCurrentLoc (params) {
      Toast.loading({
        message: this.$t('shared.loading'),
        forbidClick: true,
        duration: 0
      })
      const currentTimeLoc =
        JSON.parse(window.localStorage.getItem('currentTimeLoc')) || {}
      this.getlocation(currentTimeLoc.lat, currentTimeLoc.lng, params.address)
    },
    getlocation (lat, lng, toAddress) {
      // 根据经纬度获取位置
      new google.maps.Geocoder().geocode(
        {
          location: new google.maps.LatLng(lat, lng)
        },
        function geoResults (results, status) {
          Toast.clear()
          // 这里处理结果和上面一模一样
          if (status === google.maps.GeocoderStatus.OK) {
            window.location.href = `https://www.google.com/maps/dir/?api=1&dir_action=navigate&origin=${results[0].formatted_address}&destination=${toAddress}&waypoints=`
          } else {
            console.log('：error ' + status)
          }
        }
      )
    },
    confirmFilter (data) {
      this.filterData = data
      this.paginationList.page = 1
      this.storeList = []
      this.finished = false
      this.loading = false
      this.getStoreData(true)
      this.isLoading = false
    },
    // 获取频道文字列表xxxaaaxx
    async getStoreData (isPullDown = false) {
      Toast.loading({
        message: this.$t('shared.loading'),
        forbidClick: true,
        duration: 0
      })
      // 三星手机不能频繁获取当前定位
      const currentTimeLoc =
        JSON.parse(window.localStorage.getItem('currentTimeLoc')) || {}
      this.getStoreListData(currentTimeLoc)
    },
    getStoreListData (currentTimeLoc = {}) {
      const {
        personVal,
        userIdList,
        sortVal
      } = this.filterData
      const data = {
        ...this.paginationList,
        ...this.filterData,
        userIdList: personVal.includes('Me')
          ? [...userIdList, this.userInfo.user.id]
          : userIdList,
        sortField: sortVal ? sortVal.split('-')[0] : '',
        order: sortVal ? sortVal.split('-')[1] : '',
        ...currentTimeLoc,
        search: this.searchVal,
        incentiveType: 1
      }
      arsCustomerAppListPageApi(data)
        .then((result) => {
          Toast.clear()
          if (this.paginationList.page === 1) {
            this.storeList = []
          }
          // 没有就去请求
          this.paginationList.total = result.data.totalRow
          result.data.list.forEach(subItem => {
            subItem.newShelfList = subItem.shelfList.map(shelfItem => shelfItem.productName)
          })
          // 把新数组 与 原来的 数组 进行 合并
          this.storeList = [...this.storeList, ...result.data.list]
          // 把 loading 设置为false，表示 可以进行 下一次请求了
          this.paginationList.page++
          this.loading = false
          if (this.storeList.length === Number(this.paginationList.total)) {
            this.finished = true
          }
          this.finishedText = this.$t('tips.nothingMore')
        })
        .catch((err) => {
          console.log('err', err)
          this.loading = false
          this.finished = true
        })
    },

    // 上拉加载更多
    pullUpLoadMoreFn () {
      this.getStoreData()
    },
    getMyVisit () {
      deptTreeDeptApi().then((res) => {
        this.deptOption = this.stripInPlace(res.data)
      })
    },
    stripInPlace (list) {
      list.forEach((node) => {
        if (Array.isArray(node.children)) {
          if (node.children.length) {
            this.stripInPlace(node.children)
          } else {
            delete node.children
          }
        }
      })
      return list
    },
    // 下拉刷新
    pullDownRefreshFn () {
      // this.storeList = []
      this.resetPage()
      this.getStoreData(true)
      this.isLoading = false
    },
    resetPage () {
      this.paginationList = {
        page: 1,
        limit: 10,
        total: 0
      }
      this.storeList = []
      this.finished = false
      this.loading = false
    },
    handleSearch (val, type) {
      if (this.searchVal === '') {
        this.paginationList.page = 1
        this.storeList = []
        this.finished = false
        this.loading = false
        this.isLoading = false
      }
      if (type === 'search' && this.searchVal !== '') {
        if (this.timer) {
          clearTimeout(this.timer)
          this.timer = null
        }
        this.timer = setTimeout(() => {
          clearTimeout(this.timer)
          this.paginationList.page = 1
          this.storeList = []
          this.finished = false
          this.loading = true
          this.isLoading = false
          this.getStoreData()
        }, 800)
      } else {
        this.$nextTick(() => {
          // this.$refs.searchRef.focus()
          this.$el.querySelector('.van-field__control').focus()
        })
      }
    },
    onConfirmStore (item) {}
  }
}
</script>

<style scoped lang="less">
.search-page {
  .search-content {
    padding: 8px 10px;
    /deep/.van-cell {
      line-height: 20px;
    }
  }
  .right-header {
    display: flex;
    align-items: center;
    .icon-img {
      width: 26px;
      height: 26px;
    }
    .search-img {
      margin-right: 10px;
    }
  }
  .search-left-icon {
    margin-right: 10px;
  }
  .van-cell-info {
    // position: relative;
    display: flex;
    justify-content: space-between;
    // top: 53px;
    height: 35px;
    padding: 0 10px;
    font-size: 12px;
    background-color: #dce5f6;
    .channel-total {
      display: flex;
      align-items: center;
      flex: 1;
      .label-name {
        width: 60px;
      }
      .label-value {
        flex: 1;
        width: 66px;
      }
    }
    .channel-filter {
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 50%;
      padding-left: 10px;
      border-left: 1px solid #c8d6f1;
      &:first-child {
        border-left: none;
      }
      .filter-label {
        flex: 1;
      }
    }
  }
  .tabs-content {
    // display: flex;
    // align-items: center;
    width: 100%;
    background-color: #dce5f6;
    /deep/.van-tabs {
      width: 100%;
    }
    // /deep/.van-tabs--card {
    //   padding-top: 5px;
    // }
    // /deep/.van-tabs__nav--card {
    //   margin: 0;
    // }
    /deep/.van-tabs__wrap {
      height: 36px;
      padding-right: 0;
      background-color: #f5f5f9;
    }
    /deep/.van-tabs__nav {
      background-color: #f5f5f9;
    }
  }
  .oper-btn {
    width: 100%;
    position: fixed;
    bottom: 0;
    .mapping-btn {
      width: 100%;
      background-color: #307bff;
      font-weight: bold;
    }
  }
  /deep/.van-pull-refresh {
    // margin-top: 50px;
    .van-list {
      background-color: #fff;
    }
  }
  .no-invite-store {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 226px;
    .invite-btn {
      width: 266px;
      height: 58px;
      text-align: center;
      font-size: 16px;
      font-weight: bold;
      line-height: 58px;
      border: 1px solid #307bff;
      color: #307bff;
      border-radius: 32px;
    }
  }
}
.van-popup {
  width: 100%;
  height: 100%;
}
.filter-content,
.filter-sort-content,
.filter-info-content {
  padding: 10px 0;
  font-size: 12px;
  .filter-title {
    font-weight: bold;
    font-size: 16px;
    text-align: center;
  }
  .project-content {
    margin-top: 10px;
    height: 330px;
    overflow: auto;
    .project-item {
      display: flex;
      align-items: center;
      padding: 10px;
      height: 47px;
      border-bottom: 1px solid #dce5f6;
    }
    .choice-active {
      color: #307bff;
    }
  }
  .operate-btn {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 20px;
    /deep/.van-button {
      width: 120px;
      height: 40px;
      background-color: #dce5f6;
      border: 1px solid #dce5f6;
      border-radius: 8px;
      color: #000;
    }
  }
}
.filter-info-content {
  padding: 10px 18px 20px 18px;
  .project-content {
    height: 360px;
  }
  .filter-item {
    width: 100%;
    margin-bottom: 5px;
    .item-title {
      width: 100%;
      color: #000;
      font-weight: bold;
      font-size: 12px;
      padding: 7px 0;
    }
    .item-content {
      width: 100%;
      display: flex;
      // justify-content: space-between;
      flex-wrap: wrap;
      .filter-name {
        width: 31%;
        height: 27px;
        color: #000;
        text-align: center;
        line-height: 27px;
        font-size: 11px;
        background-color: #f3f6fc;
        border-radius: 6px;
        margin-top: 5px;
        margin-bottom: 5px;
        // padding: 0 5px;
        margin-right: 5px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
      .active-status {
        background-color: #1989fa;
        color: #fff;
      }
    }
  }
  .operate-btn {
    justify-content: space-between;
    .confirm-btn {
      width: 200px;
      color: #fff;
      background-color: #307bff;
      border: 1px solid #307bff;
    }
  }
}
</style>
